import React from 'react';
import bundleManifest from 'src/bundles_manifest.json';
import config from 'src/shared/config';
import { LoadScripts } from '../../scriptsLoader/loadScripts';

const preview3DScriptUrls = [
    config.publicPath + 'assets/libs/jquery/jquery-3.1.1.min.js',
    config.publicPath + 'assets/libs/jquery/jquery.mousewheel.js',
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_0'],
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_1'],
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_2'],
    config.publicPath + 'assets/bundles/' + bundleManifest['globals_3d_not_minify']
];

export const LoadPreview3DScripts = ({
    children,
    fallback,
    onProgress
}: {
    children: React.ReactNode;
    fallback: React.ReactNode;
    onProgress?: (progress: number) => void;
}) => {
    return (
        <LoadScripts fallback={fallback} scriptUrls={preview3DScriptUrls} onProgress={onProgress}>
            {children}
        </LoadScripts>
    );
};
